export default class ModeService {
    /**
     * Get mode (pos or portal).
     *
     * @return {String}
     */
    static getMode() {
        if (this.getPosToken()) {
            return 'pos';
        }

        return 'portal';
    }

    /**
     * In pos mode?
     *
     * @return {Boolean}
     */
    static inPosMode() {
        return this.getMode() === 'pos';
    }

    /**
     * Get token of pos.
     *
     * @return {String|null}
     */
    static getPosToken() {
        if (window.sessionStorage && window.sessionStorage.getItem('posToken')) {
            return window.sessionStorage.getItem('posToken');
        }

        return null;
    }

    /**
     * Set token of pos.
     *
     * @param {String} token
     */
    static setPosToken(token) {
        if (!window.sessionStorage) {
            return;
        }

        window.sessionStorage.setItem('posToken', token);
    }

    /**
     * Get code of event.
     *
     * @return {String}
     */
    static getEventCode() {
        return window.sessionStorage.getItem('eventCode');
    }

    /**
     * Set code of event.
     *
     * @param {String} code
     */
    static setEventCode(code) {
        window.sessionStorage.setItem('eventCode', code);
    }

    /**
     * Clear code of event.
     */
    static clearEventCode() {
        window.sessionStorage.removeItem('eventCode');
    }

    /**
     * Set POS.
     *
     * @param {Object} pos
     */
    static setPos(pos) {
        window.sessionStorage.setItem('pos', JSON.stringify(pos));
        this.setEventCode(pos.event);
    }

    /**
     * Get POS.
     *
     * @return {Object}
     */
    static getPos() {
        return JSON.parse(window.sessionStorage.getItem('pos'));
    }

    /**
     * Is this a POS of type kiosk?
     *
     * @return {boolean}
     */
    static isKiosk() {
        return this.inPosMode() && this.getPos() && this.getPos().type === 'kiosk';
    }

    /**
     * Is this a POS of type cashier?
     *
     * @return {boolean}
     */
    static isCashier() {
        return this.inPosMode() && this.getPos() && this.getPos().type === 'cashier';
    }
}
